<template>
    <ComContainer>
        <ComOneCheck v-if="bfState == 900 && page" :showFileList="true" ref="comOneCheck"
            style="margin-bottom: 10px;">
            <ComActionButton @click="batchInterview(1, 1)" text="初面通过"></ComActionButton>
            <ComActionButton @click="batchInterview(1, 2)" text="初面不通过"></ComActionButton>
            <!-- <ComActionButton @click="batchInterview(1, 3)" text="返回修改"></ComActionButton> -->
            <template slot="more">
                <div style="margin-top: 10px;display: flex;">
                    <div class="le-text">
                        <div class="le">初面地址：</div>
                        <a-input style="width:195px" v-model="address" :placeholder="`请输入初面地址`"></a-input>
                    </div>
                    <div class="le-text">
                        <div class="le">初面时间：</div>
                        <a-date-picker @change="changeTime" format="YYYY-MM-DD HH:mm:ss"
                            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" />
                    </div>
                </div>
            </template>
        </ComOneCheck>
        <ComOneCheck v-if="bfState == 1033 && page && loginType == 1 && $route.query.isResteInterview == 'yes'" :showFileList="true" ref="comOneCheck"
            style="margin-bottom: 10px;">
            <ComActionButton @click="batchInterview(2, 1)" text="面试通过"></ComActionButton>
            <ComActionButton @click="batchInterview(2, 2)" text="面试不通过"></ComActionButton>
            <ComActionButton @click="batchInterview(2, 3)" text="返回修改"></ComActionButton>
            <template slot="more">
                <div style="margin-top: 10px;display: flex;">
                    <div class="le-text">
                        <div class="le">面试地址：</div>
                        <a-input style="width:195px" v-model="address" :placeholder="`请输入面试地址`"></a-input>
                    </div>
                    <div class="le-text">
                        <div class="le">面试时间：</div>
                        <a-date-picker @change="changeTime" format="YYYY-MM-DD HH:mm:ss"
                            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" />
                    </div>
                </div>
            </template>
        </ComOneCheck>
        <ComOneCheck v-if="bfState == 1300 && page == 'physical'" :showFileList="true" ref="comOneCheck"
            style="margin-bottom: 10px;">
            <ComActionButton @click="batchCheckup()" text="提交"></ComActionButton>
            <div style="width: 100%;margin-top:6px;margin-bottom: 6px;">
                体检结果：<a-radio-group v-model="valueRadioInterview" @change="changeValueRadioInterview">
                    <a-radio :value="1">
                        通过
                    </a-radio>
                    <a-radio :value="2">
                        未通过
                    </a-radio>
                    <a-radio :value="3">
                        暂缓
                    </a-radio>
                    <a-radio :value="4">
                        放弃
                    </a-radio>
                </a-radio-group>
            </div>
            <div style="width: 100%;">
                考察结果：<a-radio-group v-model="valueRadioInspect">
                    <a-radio :disabled="valueRadioInterview == 2 || valueRadioInterview == 4 ? true : false" :value="1">
                    通过
                  </a-radio>
                  <a-radio :disabled="valueRadioInterview == 2 || valueRadioInterview == 4 ? true : false" :value="2">
                    未通过
                  </a-radio>
                  <a-radio :disabled="valueRadioInterview == 1 || valueRadioInterview == 3 ? true : false" :value="3">
                    未进行考察
                  </a-radio>
                  <a-radio :disabled="valueRadioInterview == 2 || valueRadioInterview == 4 ? true : false" :value="4">
                    放弃
                  </a-radio>
                </a-radio-group>
            </div>
        </ComOneCheck>
        <div class="com-progress">
            <ComSteps :bfStateName="bfStateName" :completeSelection="completeSelection" ></ComSteps>
        </div>
        <!--interview 面试 physical 体检 inspect 考察 result 结果公示 -->
        <div class="com-progress tab-content">
         <a-button v-if="isAdjusted === 0 && originalId" @click="openBasicInfo" class="btn-before" type="primary">查看调剂前数据</a-button>
            <InstitutionBasicInfo v-if="$route.path.includes('personal')" :id="$route.query.basicId" :isEdit="false" :isShowStep="false">
            </InstitutionBasicInfo>
            <a-tabs @tabClick="tabClick" :activeKey="defaultKey">
                <a-tab-pane v-if="page" key="0" tab="基本信息">
                        <InstitutionBasicInfo  @changeoriginalId="changeoriginalId" :id="$route.query.basicId" :isEdit="false" :isShowStep="false">
                        </InstitutionBasicInfo>
                         
                          <a-modal
                  width="1180px"
                  title="调剂前基本信息"
                  :visible="visibleBasicInfo"
                  @ok="handleOk"
                  @cancel="handleCancel"
                  :footer = 'null'
                >
                <InstitutionBasicInfo
                        :id="originalId"
                        :isEdit="$route.query.isEdit == false"
                      ></InstitutionBasicInfo>
                </a-modal>
                </a-tab-pane>
                <a-tab-pane v-if="(page && page !== 'talent-transfer-list' && bfState != 900 && this.$route.query.adjustNumber !== '1') || (page == 'employed' && data.interviewResult && data.interviewResult != -1 && this.$route.query.adjustNumber !== '1') " key="interview" tab="初步面试和面试" force-render>
                    <InfoTit>{{ loginType == 1?'初步面试情况（第一轮）':'初步面试情况' }} </InfoTit>
                    <div class="margin-left-15">
                        <div class="le-text">
                            <div class="le">初面时间：</div>
                            {{ data.interviewDate && data.interviewDate.substr(0, 10) }}
                        </div>
                        <div class="le-text">
                            <div class="le">初面地址：</div>
                            {{ data.interviewAddress }}
                        </div>
                        <div class="le-text">
                            <div class="le">初面意见：</div>
                            {{ data.interviewProcess }}
                        </div>
                        <div class="le-text">
                            <div class="le">初面结果：</div>
                            {{ data.chrInterviewResult }}
                        </div>
                        <div v-if="data?.interviewAtts" class="le-text">
                            <div class="le">证明材料：</div>
                            <ComFileList class="file-list" :list='data.interviewAtts && JSON.parse(data.interviewAtts)'
                                isDownload></ComFileList>
                        </div>
                    </div>
                    <InfoTit v-if="data?.retestResult != -1">{{ loginType == 1 ? '初步面试情况（第二轮）' : '面试情况' }} </InfoTit>
                    <div v-if="data?.retestResult != -1" class="margin-left-15">
                        <div class="le-text">
                            <div class="le">{{ loginType == 1 ? '初面时间：' : '面试时间：' }}</div>
                            {{ data.retestDate && data.retestDate.substr(0, 10) }}
                        </div>
                        <div class="le-text">
                            <div class="le">{{ loginType == 1 ? '初面地址：' : '面试地址：' }}</div>
                            {{ data.retestAddress }}
                        </div>
                        <div class="le-text">
                            <div class="le">{{ loginType == 1 ? '初面意见：' : '面试意见：' }}</div>
                            {{ data.retestProcess }}
                        </div>
                        <div class="le-text">
                            <div class="le">{{ loginType == 1 ? '初面结果：' : '面试结果：' }}</div>
                            {{ data.chrRetestResult }}
                        </div>
                        <div v-if="data?.retestAttachments" class="le-text">
                            <div class="le">证明材料：</div>
                            <ComFileList class="file-list" :list='data.retestAttachments && JSON.parse(data.retestAttachments)'
                                isDownload></ComFileList>
                        </div>
                    </div>
                      <InfoTit  v-if="data?.zgInterviewResult != -1">面试情况（主管单位）</InfoTit>
                        <div  v-if="data?.zgInterviewResult != -1" class="margin-left-15">
                             <div v-if="loginType == 2" class="le-text">
                                <div class="le">面试时间：</div>
                                {{ data.zgInterviewDate && data.zgInterviewDate.substr(0, 10) }}
                            </div>
                            <div v-if="loginType == 2" class="le-text">
                                <div class="le">面试地址：</div>
                                {{ data.zgInterviewAddress }}
                            </div>
                            <div class="le-text">
                                <div class="le">面试意见：</div>
                                {{ data.zgInterviewProcess }}
                            </div>
                            <div class="le-text">
                                <div class="le">面试结果：</div>
                                {{ data.chrZgInterviewResult }}
                            </div>
                            <div v-if="data?.zgInterviewAttachments" class="le-text">
                                <div class="le">证明材料：</div>
                                <ComFileList class="file-list" :list='data.zgInterviewAttachments && JSON.parse(data.zgInterviewAttachments)'
                                    isDownload></ComFileList>
                            </div>
                        </div>
                </a-tab-pane>
                <a-tab-pane  v-if="(page == 'physical' || (data?.checkupResult != -1 && page == 'employed')) && data?.checkupResult && data?.checkupResult != -1"
                    key="physical" tab="体检（考察）">
                    <InfoTit>体检情况</InfoTit>
                    <div class="margin-left-15">
                      <div class="le-text">
                        <div class="le">体检结果：</div>
                        {{ data.chrCheckupResult }}
                    </div>
                        <div class="le-text">
                        <div class="le">考察结果：</div>
                        {{ data.chrInvestigateResult }}
                    </div>
                        <div class="le-text">
                            <div class="le">审核意见：</div>
                            {{ data.checkupExplain }}
                        </div>
                        <div v-if="data?.checkupAtts" class="le-text">
                            <div class="le">证明材料：</div>
                            <ComFileList class="file-list" :list='data.checkupAtts && JSON.parse(data.checkupAtts)'
                                isDownload>
                            </ComFileList>
                        </div>
                    </div>
                </a-tab-pane>
                <a-tab-pane v-if="page && appealList.length>0"  key="appeal" tab="申诉过程">
                    <appeal-info :list="appealList"></appeal-info>
                </a-tab-pane>
            </a-tabs>
        </div>
        <a-button v-if="$route.query.backPage" class="back-page" type="primary" @click="backPage">返回</a-button>
    </ComContainer>
</template>

<script>
import {getAppealDetail} from '@/api/appeal'
import { mapGetters } from 'vuex'
import { batchInterview, batchInterviewRetest } from '@/api/offlineInspection'
import { batchCheckup } from '@/api/offlineInspection'
import moment from 'moment';
import ComOneCheck from '@/components/com-one-check'
import ComActionButton from '@/components/common/buttons/com-action-button.vue';
import ComSteps from '@/components/common/com-steps.vue';
import AppealInfo from '@/components/com-appeal/info.vue';
import ComContainer from '@/components/common/com-container.vue';
import InstitutionBasicInfo from '@/components/institution-basic-info/index.vue';
import InfoTit from '@/components/tit/info-tit';
import { selectDetal } from '@/api/offlineInspection'
import ComFileList from "@/components/common/com-file-list";
import { getAuditDetails } from '@/api/declaration'
export default {
    name: 'PanelDetail',
    components: {
        ComContainer,
        InfoTit,
        InstitutionBasicInfo,
        ComFileList,
        ComSteps,
        ComOneCheck,
        ComActionButton,
        AppealInfo
    },
    data() {
        return {
            // page:this.$route.query.page,
            isAdjusted: '',
            originalId: '',
            visibleBasicInfo: false,
            bfStateName:'',
            completeSelection:'',
            defaultKey: '0',
            valueRadioInterview: 1,
            valueRadioInspect: 1,
            userName: '',
            time: '',
            address: '',
            interviewName: '',
            attachment: [],
            appealList:[],
            rows: 2,
            current: 0,
            status: 'wait',
            bfState: 10,
            isProvincialUnit: 0,
            resultDetail: {},
            data: {}
        };
    },
    computed: {
        ...mapGetters(['loginType']),
        isUnit() { //是否单位端
            return this.$route.path.includes('institution');
        },
        page(){
            return this.$route.query.page
        }
    },
    watch:{
        $route:{
            handler(nv,ov){
                console.log('nv, ov',nv, ov);
                this.getData()
            },
            //  immediate: true,
             deep:true
        }
    },
    mounted() {
        // let {postId,declarerId} = this.$route.query;
        // if(postId && declarerId && this.isUnit){
        // this.getCheckAppealDetail(postId,declarerId);
        // }
        this.getData()
        // 测试
        // setTimeout(() => {
        //     this.bfState = 900
        // }, 1000)
    },
    methods: {
        backPage(){
            this.$router.back()
        },
         // isAdjusted： 1 - 被调剂 0 - 未被调剂
        // originalId：原申报数据id
        // 如果为0 没有id 说明没有被调剂过
        // 如果为1 没有id 说明是被调剂原数据
        // 如果为0 有id 说明是调剂后的新数据
        changeoriginalId(isAdjusted, originalId) {
            this.isAdjusted = isAdjusted
            this.originalId = originalId
        },
        openBasicInfo() {
            this.$router.push({ path: '/institution/talent-transfer-lists/four-detail', query: { page: 'employed', basicId: this.originalId, backPage: 'true' } })
            // this.visibleBasicInfo = true;
        },
        handleCancel() {
            this.visibleBasicInfo = false;
        },
        handleOk() {
            this.visibleBasicInfo = false;
        },
        getCheckAppealDetail(postId,appealPersonId){
            getAppealDetail({
                appealPersonId: appealPersonId,
                postId: postId
            }).then(res => {
            if (res.code == 0) {
                this.appealList = res.data;
            }
            });
        },
        changeValueRadioInterview(e) {
            if (e.target.value == 1 && this.valueRadioInspect == 3) {
                this.valueRadioInspect = 1
            } else if (e.target.value == 2) {
                this.valueRadioInspect = 3
            } else if (e.target.value == 3 && this.valueRadioInspect == 3) {
                this.valueRadioInspect = 1
            }else if(e.target.value == 4){
                this.valueRadioInspect = 3
            }
        },
        tabClick(e) {
            this.defaultKey = e
        },
        defaultKeyFn() {
            let page = this.$route.query.page
            if (page) {
                if (page == 'physical') {
                    if (this.bfState == 1300) {
                        this.defaultKey = 'interview'
                    } else {
                        this.defaultKey = page
                    }
                } else if(page == 'interview'|| page == 'talent-transfer-list') {
                    if (this.bfState == 900) {
                        this.defaultKey = '0'
                    } else {
                         if (this.loginType == 1 && this.bfState == 1033) {
                            this.defaultKey = '0'
                        }else{
                            this.defaultKey = 'interview'
                        } 
                    }
                }else if(page == 'employed'){
                    this.defaultKey = '0'
                }else {
                    this.defaultKey = page
                }
            } else {
                this.defaultKey = '0'
            }
        },
        // 批量更新初面结果
        batchInterview(interview, num) {
            console.log(this.$refs.comOneCheck.attachment, this.$refs.comOneCheck.message);
            let ids = [this.$route.query.basicId] //数据id数组
            let params = {
                "address": this.address,
                // "interviewName": this.interviewName,
                "atts": this.$refs.comOneCheck.attachment.join(","),
                ids,
                "inspectDate": this.time,
                "opinion": this.$refs.comOneCheck.message,
                "whethePass": num,
            }
            console.log('params', params);
            let routeUrl = `/institution/interview-list` //interview == 1
            if (this.$route.query.page == 'talent-transfer-list') {
                routeUrl = `/institution/talent-transfer-list`
            } else if (interview == 2) {
                routeUrl = `/institution/interview-two-list`
            }

            if (interview == 1) {
                batchInterview(params).then((res) => {
                    // console.log(res);
                    if (res.code == 0) {
                        this.$message.success('操作成功')
                    } else {
                        this.$message.error('操作失败')
                    }
                }).finally(() => {
                    this.$router.push(routeUrl)
                })
            } else {
                batchInterviewRetest(params).then((res) => {
                    // console.log(res);
                    if (res.code == 0) {
                        this.$message.success('操作成功')
                    } else {
                        this.$message.error('操作失败')
                    }
                }).finally(() => {
                    this.$router.push(routeUrl)
                })
            }
        },
         // 批量更新考察
        batchCheckup() {
            if (this.valueRadioInterview == 1 || this.valueRadioInterview == 2) {
                if (!this.data.checkupRecord || this.data.checkupRecord == '[]') {
                    this.$message.warning(`${this.userName},未上传体检报告，请重新选择`)
                } else {
                    this.batchCheckupSure()
                }
            } else {
                this.batchCheckupSure()
            }
        },
         batchCheckupSure() {
            console.log(this.$refs.comOneCheck.attachment, this.$refs.comOneCheck.message);
            let ids = [this.$route.query.basicId] //数据id数组
            let params = {
                // "address": '',
                "atts": this.$refs.comOneCheck.attachment.join(","),
                ids,
                "opinion": this.$refs.comOneCheck.message,
                "whethePass": this.valueRadioInterview,//面试结果
                inspectPass: this.valueRadioInspect //考察结果
            }
            console.log('params', params);
            batchCheckup(params).then((res) => {
                if (res.code == 0) {
                    this.$message.success('操作成功')
                    this.$router.push('/institution/physical-list')
                } else {
                    this.$message.error('操作失败')
                    this.$router.push('/institution/physical-list')
                }
                this.visible = false;
            })
        },
        moment,
        changeTime(date, dateString) {
            this.time = dateString
            console.log(date, dateString);
        },
        // 获取考察数据
        getData() {
            selectDetal({ id: this.$route.query.basicId }).then(res => {
                // console.log('获取考察数据', res);
                if (res.code == 0) {
                    this.data = res.data
                }
                getAuditDetails({ id: this.$route.query.basicId }).then((res) => {
                    if (res.code == 0) {
                        this.bfState = res.data.bfState;
                        this.bfStateName = res.data.bfStateName;
                        this.completeSelection=res.data.baseInfo?.completeSelection;
                        this.isProvincialUnit = res.data.isProvincialUnit;
                        this.userName = res.data.baseInfo.userName;
                        this.defaultKeyFn()
                        if(res.data.baseInfo.talentPostId && res.data.baseInfo.declarerId && this.isUnit){
                            this.getCheckAppealDetail(res.data.baseInfo.talentPostId, res.data.baseInfo.declarerId);
                        }
                    }
                })
            })
            
            // getResultDetail({ id: this.$route.query.basicId }).then(res => {
            //     if (res.code == 0) {
            //         this.resultDetail = res.data
            //         // console.log('this.resultDetail',  this.resultDetail);
            //     }
            // })
        },

        changeResult(num) {
            if (num == 100) {
                return '待公示'
            } else if (num == 110) {
                return '公示不通过'
            } else if (num == 120) {
                return '办结'
            }
        },
        // 转换性别
        changeGender(num) {
            if (num == 1) {
                return '女'
            } else if (num == 2) {
                return '男'
            }
        }
    },
};
</script>

<style lang="less" scoped>
.back-page{
    position: fixed;
    left: 50%;
    bottom: 50px;
    z-index: 99;
    margin-left: 600px;
}
.btn-before{
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform:translateX(-65px) ;
  z-index: 9;
}
.margin-left-15 {
    margin-left: 15px;
}

.tab-content {
    margin-top: 10px;
    min-height: 520px;
}

.com-progress {
    padding: 20px 40px;
    background: #fff;
}

.appeal-info {
    ul {
        position: relative;
        margin-left: 34px;
        margin-bottom: 20px;
        padding: 12px 12px 0;
        background: #F7F8FA;
        border-radius: 5px;

        &::after {
            position: absolute;
            content: '';
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #28B84A;
            left: -15px;
            top: 20px;
        }

        &::before {
            position: absolute;
            content: '';
            width: 2px;
            height: calc(100% - 25px);
            background: #F7F7F7;
            left: -13px;
            top: 25px;
            z-index: 0;
        }

        li {
            margin-bottom: 4px;
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;

            &:last-of-type {
                margin-bottom: 0;
            }

            .title {
                color: #111111;
                font-weight: 600;
            }

            .name {
                color: #505D6E;
            }

            .content {
                color: #111111;
            }
        }

    }
}

::v-deep {
    .le-text {
        align-items: center;
        width: 100%;

    }

    .ant-input {
        border: none;
        background-color: #F1F5F8;
    }

    .ant-steps-item {
        flex: auto;
        padding-right: 20px;

        &:last-child {
            padding-right: 0px;
        }
    }

    .icon-text-head {
        width: 1100px !important;
    }

    .left {
        margin-left: 14px !important;
    }

    .about-data {
        margin-left: 14px !important;
    }

    .knowledge-require {
        margin-left: 14px !important;
    }


    .bot {
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        margin: 0 !important;

        .bot-content {
            width: 100% !important;
            margin: 0 !important;
        }
    }

    .ant-tabs-nav .ant-tabs-tab-active {
        color: #146CB7;
    }

    .ant-tabs-ink-bar {
        background-color: #146CB7;
    }
}
</style>
